import { render, staticRenderFns } from "./Designations.vue?vue&type=template&id=641a7286&scoped=true"
import script from "./Designations.vue?vue&type=script&lang=js"
export * from "./Designations.vue?vue&type=script&lang=js"
import style0 from "./Designations.vue?vue&type=style&index=0&id=641a7286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a7286",
  null
  
)

export default component.exports